<template>
  <div
    ref="cardBox"
    class="card-box"
    :class="[
      { 'has-bg': backgroundColor || backgroundClass },
      backgroundColor ? '' : backgroundClass,
      layout,
      {'is-narrow': isNarrow}
    ]"
    :style="backgroundColor ? `backgroundColor: ${backgroundColor}` : ''"
  >
    <ContentGeneratorElementsMedia
      :value="content?.media"
      :aspect-ratio="aspectRatio"
      :aspect-ratio-mobile="aspectRatioMobile"
      size-image="w2000"
    />
    <ContentGeneratorElementsText :content="content?.text" />
  </div>
</template>

<script>
import ContentGeneratorElementsText from '../elements/Text.vue'
import ContentGeneratorElementsMedia from '../elements/Media.vue'
import { contentFindContent, contentFindOption } from '../../../plugins/content'
export default {
  name: 'CardBox',
  components: {
    ContentGeneratorElementsText,
    ContentGeneratorElementsMedia
  },
  props: {
    value: { type: Object, default: null }
  },
  data () {
    return {
      isNarrow: false,
      resizeObserver: null
    }
  },
  computed: {
    aspectRatio () {
      return this.value?.options?.find(el => el.key === 'aspectRatio')?.value || '1/1'
    },
    aspectRatioMobile () {
      return this.value?.options?.find(el => el.key === 'aspectRatioMobile')?.value || '1/1'
    },
    content () {
      return {
        media: contentFindContent(this.value?.content, 'media'),
        text: contentFindContent(this.value?.content, 'text')
      }
    },
    backgroundColor () {
      return contentFindOption(this.value.options, 'backgroundColor').value || null
    },
    backgroundClass () { return contentFindOption(this.value.options, 'backgroundClass').value || null },

    layout () {
      return contentFindOption(this.value.options, 'layout').value || 'photo-text'
    }
  },
  mounted () {
    this.observeResize()
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    observeResize () {
      this.resizeObserver = new ResizeObserver((entries) => {
        requestAnimationFrame(() => {
          for (const entry of entries) {
            const width = entry.contentRect.width
            this.isNarrow = width < 768
          }
        })
      })
      this.resizeObserver.observe(this.$refs.cardBox)
    }
  }

}

</script>

<style lang="scss" scoped>
.card-box {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  :deep(figure){
    margin-bottom: 0;
    height: auto;
  }
  :deep(.photo-wrapper){
    height: auto;
  }

  :deep(.text-container) {
    order: 2;
    .text{
      & > :first-child{
      margin-top: 0;
    }
    }

    p {
      display: -webkit-box;
      -webkit-line-clamp: 8;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  &.is-narrow{
    :deep(.text-container){
      padding: 24px 32px;
      .text{

        p{
          margin: 0;
        }
      }
    }
  }

  .photo-wrapper {
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    border-radius: 20px;

    :deep(.video) {
      border-radius: 20px;
    }

    @include mobile {
      display: block;
      width: 100%;
      height: auto;
      // aspect-ratio: 1/1;
      border-radius: 20px;
      background-color: $light-gray;
      background-size: cover;

      :deep(.video) {
        border-radius: 0;
      }
    }
  }
  &.has-bg.photo-text {
    :deep(figure) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      img, video {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    :deep(.photo-wrapper){
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      .video{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      video{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    :deep(.text-container) {
      margin: 0;
      padding: 32px;

      & > :first-child {
        margin-top: 0;
      }
    }
  }
  &.text-photo {
    height: 100%;
    display: flex;
    justify-content: space-between;

    & > * {
      margin-bottom: 32px;
    }

    :deep(.text-container) {
      order: 1;
      margin-top: 0;
    }
    &.has-bg{
          :deep(.photo-wrapper) {
      order: 2;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      .video{
        border-top-left-radius: 0;
      border-top-right-radius: 0;
      video{
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      }
      figure{
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        img{
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
      }
    }

    }

    :deep(.photo-wrapper) {
      order: 2;
    }

    &.has-bg {
      & > * {
        margin-bottom: 0;
      }

      :deep(figure) {
        border-radius: 0 0 20px 20px;

        img {
          border-radius: 0 0 20px 20px;
        }
      }

      :deep(.text) {
        margin: 0;
      }
    }
  }
  &:not(.has-bg){
    :deep(.text-container){
      padding: 24px 0;
    }
  }
}
</style>
